/* eslint-disable import/no-named-as-default-member */
import Tracking from '@spotahome/soyuz-tracking';
import { Mediator } from '@spotahome/soyuz-mediator';
import { clientErrorTracker } from '@spotahome/soyuz/client';

import getGqlClient from '../graphql/client';
import { addAlert } from '../graphql/mutations/alerts';
import { OPEN_APPLIED_FILTERS_MODAL } from '../channels';
import SoyuzLocalStorage from '../utils/soyuzLocalStorage';
import { showSuccessToast } from '../components/AlertToast';

export const LOCAL_STORAGE_ALERT_DATA_KEY = 'alertData';
export const QUICK_ALERT_STORAGE_DATA = 'quick-alert-data';

export const createAlert = async (alertData, isQuickAlertCreation) => {
  try {
    await addAlert(getGqlClient())(alertData);
    Tracking.ga.sendEvent(
      'My alerts modal',
      'alert creation success',
      'alert creation success'
    );
    if (isQuickAlertCreation) {
      Mediator.publish(OPEN_APPLIED_FILTERS_MODAL);
      SoyuzLocalStorage.removeItem(QUICK_ALERT_STORAGE_DATA);
    } else {
      SoyuzLocalStorage.removeItem(LOCAL_STORAGE_ALERT_DATA_KEY);
      showSuccessToast();
    }
  } catch (error) {
    clientErrorTracker.error({ error, source: 'CreateAlert' });
  }
};

const parseBudget = (budget = '') => {
  const splitBudget = budget.split('-');
  return {
    minPrice: splitBudget[0],
    maxPrice: splitBudget[1]
  };
};

export const getAlertFromFilters = (cityId, filters) => ({
  cityId,
  moveIn: filters['move-in'],
  moveOut: filters['move-out'],
  moveInFrom: filters.moveInFrom,
  moveInTo: filters.moveInTo,
  moveOutFrom: filters.moveOutFrom,
  moveOutTo: filters.moveOutTo,
  propertyTypes: filters['type[]'],
  cityAreaIds: filters['areaId[]'],
  bathrooms: filters['bathrooms[]'],
  bed: filters.bed,
  features: filters['features[]'],
  instantBooking: filters.instantBooking,
  noDeposit: filters.noDeposit,
  verified: filters.verified,
  topology: filters['topology[]'],
  rentalType: filters['rentalType[]'],
  ...parseBudget(filters.budget)
});

export const getAlertDataFromStorage = storageKey => {
  // eslint-disable-next-line import/no-named-as-default-member
  const data = SoyuzLocalStorage.extractItem(storageKey);
  try {
    return JSON.parse(data);
  } catch (e) {
    return null;
  }
};

export default {
  createAlert,
  parseBudget,
  getAlertFromFilters,
  getAlertDataFromStorage
};
